import React from "react";

export const withNewlines = (str: string) =>
	str.split("\n").map((text, i) => (
		<React.Fragment key={`${text}-${i}`}>
			{text}
			<br/>
		</React.Fragment>
	));
